import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import size from 'lodash/size';
import { handlePreview } from '@/components/Common/PreviewImage';
import './index.less';
import Image from 'next/image';
import classNames from 'classnames';
import Spinner from '@/components/Common/Spinner';
import CarouselNextArrowIcon from '@/components/Common/Icons/CarouselNextArrowIcon';
import CarouselBackArrowIcon from '@/components/Common/Icons/CarouselBackArrowIcon';

interface IProps {
  images: string[];
  alt: string;
  id?: string;
}

const ImageWithThumbnails = ({ images, alt, id }: IProps) => {
  const imagesEqualOne = images.length === 1;
  const sliderSettings = {
    dots: false,
    speed: 300,
    rows: 2,
    slidesToShow: 3,
    infinite: false,
    centerPadding: '60px',
    slidesToScroll: 1,
    draggable: true,
    arrows: true,
    nextArrow: <CarouselNextArrowIcon />,
    prevArrow: <CarouselBackArrowIcon />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 1,
        },
      },
    ],
  };

  const firstImage = images[0];

  return (
    <div className="image-with-thumbnails" id={id}>
      <div className={classNames('selected-image-container', { 'full-image-container': imagesEqualOne })}>
        <Image
          className="selected-image"
          src={firstImage}
          alt={alt || 'Selected Image'}
          width={240}
          height={240}
          sizes="(min-width: 1116px and max-width:1280px) 240px,(min-width: 1440px) 240px, 200px"
          onClick={() => handlePreview({ urls: [firstImage], current: 0 })}
          loading="eager"
          fetchPriority="high"
        />
      </div>
      {size(images) > 1 && (
        <div className="carousel-container">
          <div className="carousel">
            <Slider {...sliderSettings} className="slider">
              {images.map((img, i) => {
                if (!img) {
                  return <Spinner key={i} />;
                } else {
                  return (
                    <>
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      <Image
                        className="thumbnail-image"
                        key={i}
                        width={96}
                        height={88}
                        src={img}
                        onClick={() => handlePreview({ urls: [img], current: 0 })}
                        alt={alt || 'Thumbnail image No.' + i}
                        fetchPriority="low"
                      />
                    </>
                  );
                }
              })}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageWithThumbnails;
